// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const { getLanguage } = require('core/i18n').i18n;


const setMainAccountIsFetching = () => ({
    type: actionTypes.SET_MAIN_ACCOUNT_REQUEST,
});

const setMainAccountSuccess = response => ({
    type: actionTypes.SET_MAIN_ACCOUNT_SUCCESS,
    payload: {
        response
    }
});

const setMainAccountFailure = () => ({
    type: actionTypes.SET_MAIN_ACCOUNT_FAILURE,
});

const getMainAccount = (accountIdentifier = '', originCountry = '') => (dispatch) => {
    dispatch(setMainAccountIsFetching());

    const requestData = {
        accountIdentifier,
        lang: getLanguage(),
    };

    return APIGet(dispatch, apiURLBuilder.getURL('accountOffers', requestData))
        .then(response => {
            dispatch(setMainAccountSuccess(response));
        })
        .catch(response => {
            if (response.error) {
                dispatch(setMainAccountFailure());
            } else {
                throw response;
            }
        });
};

module.exports = {
    getMainAccount,
};
